module.exports = __webpack_public_path__ + "img/pointEchart.dcd44ac2.png";